const chunkLoadErrorMessagePattern = /dynamically imported module|Importing a module script failed/i;

const isChunkLoadError = (error: unknown): boolean =>
	error instanceof Error && (error.name === "ChunkLoadError" || chunkLoadErrorMessagePattern.test(error.message));

export default isChunkLoadError;
